const catalogLang = {
  menuTitle: 'Catalogue',
  product: {
    label: 'Produit',
    menu: 'Produits',
    listTitle: 'Liste des produits',
    addTitle: 'Nouveau produit',
    editTitle: 'Modification d\'un produit',
    addLabel: 'Créer un produit',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
    itemTitle: 'Fiche produit',
    clone: 'Cloner le produit'
  },
  providerReferences: {
    menu: 'Références fournisseurs',
    listTitle: 'Liste des références fournisseurs'
  },
  service: {
    label: 'Prestation',
    menu: 'Prestations',
    listTitle: 'Liste des prestations',
    addTitle: 'Nouvelle prestation',
    editTitle: 'Modification d\'une prestation',
    addLabel: 'Créer une prestation',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette prestation ?',
    itemTitle: 'Fiche prestation',
    clone: 'Cloner la prestation'
  },
  group: {
    label: 'Groupe',
    menu: 'Groupes',
    listTitle: 'Liste des groupes',
    addTitle: 'Nouveau groupe',
    editTitle: 'Modification d\'un groupe',
    addLabel: 'Créer un groupe',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
    itemTitle: 'Fiche groupe',
    clone: 'Cloner le groupe'
  },
  stock: {
    menuTitle: 'Stock',
    commandsListTitle: 'Liste des commandes fournisseurs',
    addLabel: 'Créer une commande',
    mvtListPagetitle: 'Liste des mouvements de stock',
    manualMvtListPagetitle: 'Liste des entrées et sorties manuelles de stock',
    manualAddTitle: 'Création d\'un mouvement de stock',
    manualEditTitle: 'Modification d\'un mouvement de stock',
    StockStatePagetitle: 'État du stock',
    addManual: 'Nouveau mouvement de stock',
    params: {
      referenceNormal: 'Normal',
      referenceMonth: 'Remise à 0 tous les mois',
      referenceYear: 'Remise à 0 tous les ans',
      inStock1: 'Lorsque les produits sont marqués comme livré sur une commande fournisseur',
      inStock2: 'À la création d\'une commande fournisseur (peu importe le statut)',
      outStock1: 'Lorsque le bon de livraison est marqué comme envoyé',
      outStock2: 'Lorsque le bon de livraison est marqué comme "À envoyer"',
      outStock3: 'À la création d\'un bon de livraison (Brouillon)',
      outStock4: 'À la validation d\'un devis',
      outStock5: 'À la validation d\'un bon de commande',
      outStock6: 'À la validation d\'un devis ou d\'un bon de commande',
      outStock7: 'À la création d\'une facture',
      paramsTitle: 'Paramètres',
      theoricaltitle: 'Mouvements de stock théorique',
      theorical: 'théorique',
      addToStock: 'Ajouter les produits au stock :',
      removeFromStock: 'Sortir les produits au stock :',
      realTitle: 'Mouvements de stock réel',
      stockValueTitle: 'Calcul de la valeur de stock',
      stockValueOptions1: 'Calculer la valeur du stock en fonction du prix d\'achat',
      stockValueOptions2: 'Calculer la valeur du stock en fonction du prix unitaire moyen pondéré',
      stockValueExplain1: 'Le prix unitaire moyen pondéré sera calculé en fonction des commandes fournisseurs.',
      stockValueExplain2: 'Si aucune commande fournisseur n\'est présente ou que la quantité en stock est négative, le prix d\'achat sera alors utilisé.',
      providerCommandStock: 'Remplir automatiquement les quantités en se basant sur',
      providerCommandStockOption1: 'Le stock réel',
      providerCommandStockOption2: 'Le stock théorique',
      providerCommandStockDraft: 'Par défaut, ajouter les produits aux commandes fournisseur existantes',
      real: 'réel',
      realExplain1: 'Lorsque la gestion des stocks avec traçabilité est activée sur un produit, il est obligatoire :',
      realExplain2: 'D\'effectuer un bon de livraison pour sortir le(s) produit(s) concerné(s) du stock',
      realExplain3: 'De passer par la réception de la commande fournisseur ou une entrée de stock manuelle pour les entrées de stock',
      notificationTitle: 'Notifications',
      receiveNotification: 'Recevoir un email quand :',
      productThreshold: 'un produit atteint le seuil d\'alerte {mode}',
      productMin: 'un produit atteint le seuil minimum {mode}',
      productEmpty: 'un produit n\'a plus de stock {mode}',
      productMax: 'un produit atteint le seuil maximum {mode}',
      notificationRecipients: 'Destinataire(s) des notifications :',
      providerCommand: 'Commandes fournisseurs',
      defaultParams: 'Paramètres par défaut des commandes',
      pdfOptions: 'Options du bon de commande PDF',
      showContact: 'Afficher le contact',
      showReference: 'Afficher la colonne référence',
      showUnit: 'Afficher les unités',
      notshowPrices: 'Ne pas afficher les prix',
      formOptions: 'Options de saisie',
      canSelectAllProduct: 'Permettre de sélectionner des produits non reliés au fournisseur',
      updateProductPrice: 'Mettre à jour les prix d\'achat des produits en fonction des prix de la commande',
      calculateProductCosts: 'Permettre de modifier les coûts divers des différents produits lors de la saisie de la commande',
      defaultDeliveryAddress: 'Adresse de livraison par défaut',
      emptyDeliveryAddress: 'Laisser vide pour utiliser l\'adresse de votre entreprise',
      defaultStatus: 'Statut par défaut lors la création des commandes :',
      statusExplain: 'Si la commande est créée au statut livrée, alors les produits sont automatiquement ajoutés au stock.',
      referenceTitle: 'Référence des commandes fournisseurs',
      manualMovement: 'Mouvements de stock manuels',
      manualMovementReferenceTitle: 'Référence des mouvements de stock manuels',
    },
    types: {
      stockManualContentEntry: 'Entrée de stock n°{reference}',
      stockManualContentOuput: 'Sortie de stock n°{reference}',
      stockManualContentDelete: 'Mouvement de stock supprimé',
      providerCommand: 'Commande fournisseur n°{reference}',
      providerCommandDelete: 'Commande fournisseur supprimée',
      product: 'Produit',
      group: 'Groupe',
      productVariation: 'Variation du produit',
      productLot: 'Lot',
      quotation: 'Devis n°{reference}',
      quotationDelete: 'Devis supprimé',
      command: 'Bon de commande n°{reference}',
      commandDelete: 'Bon de commande supprimé',
      proforma: 'Facture proforma n°{reference}',
      proformaDelete: 'Facture proforma supprimée',
      delivery: 'Bon de livraison n°{reference}',
      deliveryDelete: 'Bon de livraison supprimé',
      invoice: 'Facture n°{reference}',
      invoiceDelete: 'Facture supprimée',
      credit: 'Avoir n°{reference}',
      creditDelete: 'Avoir supprimé'
    }
  },
  manualMovement: {
    type: {
      1: 'Entrée',
      2: 'Sortie',
      3: 'Transfert'
    },
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mouvement de stock ?',
    lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité inférieure à la quantité renseignée au préalable ne supprimera pas le(s) lot(s) déjà rentré(s) dans le stock, vous devez supprimer le(s) lot(s) manuellement.',
    lotExplain2: 'Dans le cas des gestions de stock avec lot, supprimer un produit ne supprimera pas le(s) lot(s) déjà rentré(s) dans le stock, vous devez supprimer le(s) lot(s) manuellement.'
  },
  form: {
    status: {
      disable: 'Désactivé',
      enable: 'Actif',
      notForSale: 'Non destiné à la vente'
    },
    traceabilities: {
      no: 'Non',
      lot: 'Tracabilité avec gestion des lots et des dates de péremption',
      serial: 'Tracabilité avec gestion des numéros de série et de la garantie'
    },
    variationLevels: {
      no: 'Ce produit ne comporte aucune variation',
      level: '1 niveau | {count} niveaux'
    },
    duplicateProviderReferenceError: 'Vous ne pouvez pas utiliser deux fois la même référence pour le même fournisseur',
    duplicateVariationLevelError: 'Vous ne pouvez pas utiliser deux fois la même variation'
  },
  list: {
    reference: 'Référence',
    providerReference: 'Référence fournisseur',
    name: 'Nom',
    providerName: 'Fournisseur',
    designation: 'Description',
    cantChangePrice: 'Prix modifiable',
    unitPriceHt: 'Prix U. HT',
    unitPriceTva: 'Prix U. TVA',
    unitPriceTtc: 'Prix U. TTC',
    defaultQuantity: 'Quantité par défaut',
    totalHt: 'Total HT',
    totalTva: 'Total TVA',
    totalTtc: 'Total TTC',
    unitBuyPriceHt: 'Prix d\'achat U. HT',
    variousCosts: 'Coûts divers',
    totalCosts: 'Coûts totaux',
    grossMarginAmount: 'Marge brute HT',
    grossMarginRate: 'Taux de marge',
    markupRate: 'Taux de marque',
    vatRate: 'Taux de TVA',
    unit: 'Unité',
    notForSale: 'Non destiné à la vente',
    saleCategory: 'Catégorie de vente',
    chargeCategory: 'Catégorie de charge',
    ean: 'Code EAN',
    unitWeight: 'Poids unitaire',
    sizeLength: 'Longueur',
    sizeWidth: 'Largeur',
    sizeHeight: 'Hauteur',
    ecoTaxHt: 'Éco-participation HT',
    ecoTaxTva: 'Éco-participation TVA',
    ecoTaxTtc: 'Éco-participation TTC',
    withStock: 'Gestion de stock',
    averageBuyPrice: 'Coût unitaire pondéré',
    stockQuantity: 'Quantité réelle en stock',
    stockTotal: 'Total stock HT',
    stockTheoreticalQuantity: 'Quantité théorique en stock',
    stockTheoreticalTotal: 'Total stock théorique HT',
    stockMinimum: 'Stock minimum',
    stockMaximum: 'Stock maximum',
    stockAlert: 'Stock : Niveau d\'alerte',
    stockTrackingMode: 'Stock : Traçabilité',
    variationsLength: 'Avec variations',
    variationsLevel1: 'Niveau de variation 1',
    variationsLevel2: 'Niveau de variation 2',
    variationsLevel3: 'Niveau de variation 3',
    providers: 'Fournisseur(s)',
    providersReferences: 'Référence(s) Fournisseur(s)',
    providersVariousCosts: 'Coûts divers fournisseur(s)',
    providersBuyPrice: 'Prix d\'achat HT fournisseur(s)',
    providersTotalCosts: 'Coûts total fournisseur(s)',
    hourlyPersonCost: 'Coûts horaire',
    productsCosts: 'Coûts du contenu',
    workforceCosts: 'Coûts de la main d\'oeuvre',
    durationMn: 'Durée en mn',
    durationHour: 'Durée en heure',
    numberPeopleNeeded: 'Nombre de technicien requis',

  },
  filters: {
    reference: 'Référence :',
    name: 'Nom :',
    saleCategory: 'Catégorie(s) de vente :',
    chargeCategory: 'Catégorie(s) de charge :',
    status: 'Statut :',
    notForSale: 'Non-destiné à la vente :',
    withStock: 'Avec gestion de stock :',
    withVariations: 'Comporte des variations :',
    provider: 'Fournisseur(s) :',
    product: 'Produit(s) :',
    ean: 'Code EAN :'
  },
  params: {
    menu: 'Catalogue',
    pageTitle: 'Configuration du catalogue',
    referenceManual: 'Renseigner manuellement',
    referenceTitle: 'Références des éléments du catalogue',
    referenceExplain: 'La référence est obligatoire pour chaque élément (produit, prestation ou groupe). Celle-ci doit être unique pour un type d\'élément et ne peut donc pas être utilisée deux fois sur deux produits différents (par exemple). Si vous ne souhaitez pas gérer l\'attribution des références vous-même, vous pouvez activer l\'attribution automatique ci-dessous.',
    referencePrefix: 'Préfixe',
    referenceNextNumber: 'Prochain numéro',
    referenceLength: 'Longueur des chiffres',
    hourlyPersonCost: 'Coûts horaire moyen d\'un technicien :',
    hourlyPersonCostExplain: 'Cette valeur est utilisée pour calculer le coût des prestations. Elle pourra être modifiée directement lors de la création / modification d\'une prestation.',
    activeStockDefault: 'Activer le stock par défaut pour les nouveaux produits'
  },
  productVariations: {
    menu: 'Variations des produits',
    pageTitle: 'Gestion des variations des produits',
    label: 'Nom de la variation',
    nbVariations: 'Nombre de valeurs',
    nbProducts: 'Nombre de produits utlisant la variation',
    new: 'Création d\'une variation de produit',
    edit: 'Modification d\'une variation de produit',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette variation de produit ?',
    deleteAlertMessage: 'Attention : Toutes les variations de produit utilisant cette variation seront supprimées.',
    manageVariations: 'Gérer les valeurs pour cette variation',
    valuesModalTitle: 'Gestion des valeurs d\'une variation',
    newValue: 'Création d\'une valeur pour la variation',
    editValue: 'Modification d\'une valeur pour la variation',
    deleteValueMsg: 'Êtes-vous sûr de vouloir supprimer cette valeur de variation ?',
    deleteValueAlertMessage: 'Attention : Toutes les variations de produit utilisant cette valeur de variation seront supprimées.',
    labelValue: 'Nom de la valeur',
    nbVariationsValue: 'Nombre de variations de produit utilisant cette valeur'
  },
  config: {
    menu: 'Stock',
    menuTitle: 'Ventes',
    pageTitle: 'Configuration du stock'
  },
  catalogSearch: {
    placeholder: 'Rechercher un produit, une prestation...',
    goToCatalog: 'Accéder au catalogue',
    noResults: 'Aucun résultat',
    askAddElement: 'Souhaitez-vous ajouter l\'élément au document ?'
  },
  pictures: {
    addLabel: 'Ajouter des photos',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette photo ?',
    markDefault: 'Marquer comme photo par défaut'
  },
  command: {
    addTitle: 'Création d\'une commande fournisseur',
    editTitle: 'Modification d\'une commande fournisseur',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
    form: {
      title: 'Titre',
      date: 'Date',
      provider: 'Fournisseur',
      deliveryAddress: 'Adresse de livraison',
      road: 'Rue',
      currency: 'Devise',
      pdfModel: 'Modèle PDF',
      comments: 'Commentaires',
      pdfOptions: 'Options du PDF :',
      pdfShowContact: 'Afficher le contact',
      pdfShowReference: 'Afficher la colonne référence',
      pdfShowUnit: 'Afficher les unités',
      pdfDontShowPrices: 'Ne pas afficher les prix',
      needManualReceipt: 'Lors de l\'utilisation de produit avec gestion de stock avec traçabilité, il n\'est pas possible de passer la commande en livrée directement',
      content: 'Contenu de la commande',
      productSearch: 'Rechercher un produit...',
      needSelectProvider: 'Vous devez sélectionner un fournisseur avant de pouvoir sélectionner un produit',
      emptyLine: 'Ligne vide',
      reference: 'Référence',
      designation: 'Désignation',
      unitPriceHt: 'Prix U. HT',
      vatRate: 'Taux TVA',
      quantity: 'Quantité',
      totalHt: 'Total HT',
      emptyCommand: 'Le contenu de la commande est vide',
      cantDeleteLine: 'Il n\'est pas possible de supprimer cette ligne car des lots y sont liés. Supprimer les lots avant de supprimer la ligne.',
      sidebar: {
        sidebarPosition: 'Modifier la position de la barre',
        fullscreen: 'Plein écran',
        totalHt: 'Total HT',
        totalTva: 'Total TVA',
        totalTtc: 'Total TTC'
      },
      lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité inférieure à la quantité déjà livrée ne supprimera pas le lot et n\'influera donc pas sur le stock. Vous devez supprimer manuellement le lot avant de modifier la commande.'
    },
    list: {
      reference: 'Référence',
      date: 'Date',
      title: 'Titre',
      provider: 'Fournisseur',
      contact: 'Contact',
      road1: 'Adresse de livraison - Rue 1',
      road2: 'Adresse de livraison - Rue 2',
      road3: 'Adresse de livraison - Rue 3',
      postalCode: 'Adresse de livraison - Code postal',
      town: 'Adresse de livraison - Ville',
      country: 'Adresse de livraison - Pays',
      comments: 'Commentaires',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      status: 'Statut'
    },
    filter: {
      reference: 'Référence',
      period: 'Date',
      provider: 'Fournisseur',
      status: 'Statut'
    },
    status: {
      draft: 'Brouillon',
      waitDelivery: 'En attente de livraison',
      partiallyDelivered: 'Livrée partiellement',
      delivered: 'Livrée',
    },
    receipt: {
      allDelivered: 'Tout marquer comme livré',
      reference: 'Réf.',
      designation: 'Désignation',
      commandQty: 'Qté cmd',
      deliveredQty: 'Déjà livrée',
      toDeliverQty: 'Qté restante',
      qty: 'Qté',
      lotExplain: 'Dans le cas des gestions de stock avec lot, mettre une quantité négative modifie les quantités livrées mais ne supprime pas le lot et n\'influe donc pas sur le stock. Par contre, supprimer le(s) lot(s) mettra automatiquement à jour le stock et les quantitées livrées sur la commande.',
      lotNumber: 'N° de lot',
      expirationDate: 'Date d\'expiration',
      lotQty: 'Quantité dans le lot',
      serial: 'N° de série',
      automaticGeneration: 'Générer des numéros de série chronologique'
    }
  },
  customPrices: {
    types: 'Type de prix personnalisés :',
    qtyOnDocument: 'Quantité présente sur le document',
    qtyCurrentYear: 'Quantité commandée entre le 01 janvier et le 31 décembre de l\'année en cours',
    qtyPreviousYear: 'Quantité commandée entre le 01 janvier et le 31 décembre de l\'année précédente',
    qtyLastMonths: 'Quantité commandée sur les X derniers mois',
    qtyLastNbMonths: 'Quantité commandée sur le dernier mois | Quantité commandée sur les {count) derniers mois',
    qtyTotal: 'Quantité totale commandée',
    decreasingPrices: 'Prix dégressif selon la quantité',
    decreasingPricesCondition: 'Appliquer les prix dégressifs selon :',
    decreasingPricesNbMonth: 'Nombre de mois à prendre en compte :',
    decreasingPricesList: 'Liste des prix dégressifs :',
    qtyMin: 'Quantité minimum',
    qtyMax: 'Quantité maximum',
    unitPriceHt: 'Prix U. HT',
    noCustomPrice: 'Aucun prix personnalisé',
    addCustomPrice: 'Ajouter un prix personnalisé',
    customer: 'Client',
    byCustomerType: 'Prix par type de client',
    byCustomerTypeExplain: 'Personnalisez le prix selon le type de client. Laisser le prix vide pour ne pas appliquer de prix personnalisé.',
    byCustomer: 'Prix selon un client en particulier',
    byCustomerExplain: 'Personnalisez le prix selon un client en particulier',
    byCountry: 'Prix selon le pays du client',
    byCountryExplain: 'Personnalisez le prix selon le pays du client',
    country: 'Pays'
  },
  saleCategory: {
    menu: 'Catégories de vente',
    pageTitle: 'Gestion des catégories de vente',
    label: 'Nom de la catégorie',
    parentLabel: 'Catégorie parente',
    accountLabel: 'Compte comptable',
    new: 'Création d\'une catégorie de vente',
    edit: 'Modification d\'une catégorie de vente',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de vente ?',
    accountByVatRate: 'Comptes ',
    form: {
      name: 'Nom de la catégorie :',
      parent: 'Catégorie parente :',
      accountNumberLabel: 'N° de compte (plan comptable) :',
      accountByVatRate: 'Utiliser un compte par taux de TVA',
      vatRate: 'Taux de TVA',
      accountNumber: 'N° de compte'
    }
  },
  chargeCategory: {
    menu: 'Catégories de charge',
    pageTitle: 'Gestion des catégories de charge',
    label: 'Nom de la catégorie de charge',
    parentLabel: 'Catégorie parente',
    accountLabel: 'Numéro de compte comptable',
    new: 'Création de la catégorie de charge',
    edit: 'Modification de la catégorie de charge',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de charge ?',
    deleteAlertMsg: 'Attention, la suppression d\'une catégorie parente entraînera la suppression de toutes les catégories enfants.',
    replacementComments: 'Cette catégorie est utilisée, elle doit donc être fusionnée avec une autre catégorie afin que le logiciel fonctionne normalement.'
  },
  references: {
    referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
    referenceYear4: 'l\'année sur 4 chiffres',
    referenceYear2: 'l\'année sur 2 chiffres',
    referenceMonth: 'le mois',
    referenceDay: 'le jour',
    referenceTitle: 'Numérotation des documents',
    referencePrefix: 'Préfixe',
    referenceNextNumber: 'Prochain numéro',
    referenceTypeNumber: 'Type de numérotation',
    referenceLength: 'Nombre de chiffre'
  },
  productLot: {
    pageTitle: 'Liste des lots de produits',
    editTitle: 'Modification d\'un lot',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce lot de produit ?',
    deleteMsgAlertCommand: 'La suppression du lot entraînera la mise à jour des quantités livrées sur la commande fournisseur liée.',
    deleteMsgAlertMovement: 'La suppression du lot entraînera la mise à jour des quantités livrées sur l\'entrée/sortie de stock manuelle.',
    list: {
      productReference: 'Référence du produit',
      productName: 'Nom du produit',
      reference: 'N° de lot/série',
      expire: 'Date de péremption/fin de garantie',
      quantity: 'Quantité',
      stockQuantity: 'Quantité en stock'
    },
    filter: {
      productReference: 'Référence produit',
      reference: 'N° de lot/série',
      expire: 'Date de péremption/fin de garantie',
      inStock: 'En stock'
    },
    form: {
      productReference: 'Réf. Produit',
      productName: 'Nom produit',
      reference1: 'Numéro du lot',
      reference2: 'Numéro de série',
      expire1: 'Date de péremption',
      expire2: 'Date de fin de garantie',
      quantity: 'Quantité',
      stockQuantity: 'Quantité en stock'
    }
  },
  sales: {
    list: {
      documentReference: 'N° document',
      date: 'Date',
      customer: 'Client',
      contact: 'Contact',
      unitPriceHt: 'Prix U. HT',
      unitPriceTva: 'Prix U. TVA',
      unitPriceTtc: 'Prix U. TTC',
      catalogCostU: 'Prix d\'achat U.',
      variousCostU: 'Coûts divers U.',
      totalCostU: 'Coûts total U.',
      hourlyPersonCost: 'Coûts horaire',
      numberPeopleNeeded: 'Nb technicien',
      duration: 'Durée U.',
      workforceCostsU: 'Main d\'oeuvre U.',
      totalChargeU: 'Total charge U.',
      grossMarginAmountU: 'Marge brute HT U.',
      quantity: 'Quantité',
      secondaryQuantity: 'Quantité 2',
      totalQuantity: 'Quantité totale',
      vatRate: 'Taux TVA',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      totalCatalogCosts: 'Total coûts achats',
      totalVariousCosts: 'Total coûts divers',
      totalCosts: 'Coûts total',
      totalDurationHour: 'Durée totale (H)',
      totalWorkforce: 'Total main d\'oeuvre',
      totalCharge: 'Charge totale',
      grossMarginAmount: 'Marge brute',
      grossMarginRate: 'Taux de marge',
      markupRate: 'Taux de marque'
    },
    filter: {
      period: 'Date du document',
      customer: 'Client(s)'
    }
  },
  statistics: {
    since: 'Début',
    until: 'Fin',
    ca: 'Chiffre d\'affaires :',
    salesQuantities: 'Quantités vendues :',
    totalCosts: 'Total coûts :',
    totalGrossMargin: 'Total marge HT :',
    averageUnitPrice: 'Prix de vente moyen :',
    averageQuantities: 'Quantités moyennes vendues :',
    averageCosts: 'Coûts moyens :',
    averageGrossMargin: 'Marge moyenne :',
    other: 'Autres statistiques :',
    salesPerCustomers: 'Ventes par clients',
    customersWithoutSales: 'Clients sans achat',
    tables: {
      reference: 'Référence',
      name: 'Nom',
      period: 'Filtrer par date',
      customer: 'Client',
      quantity: 'Quantité',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      buyPrice: 'Prix d\'achat',
      variousCosts: 'Coûts divers',
      totalCosts: 'Coûts total',
      duration: 'Durée (H)',
      workforce: 'Coûts main d\'oeuvre',
      charge: 'Total charges',
      grossMargin: 'Marge brute HT'
    }
  }
}

export default {
  catalog: catalogLang
}
